import type { PlayerStats, PlayerStatsSnapshot } from '../../gameplay/player';
import { createStatRow, applyBar } from './shared';

export class AstronautStatsHUD {
  readonly element: HTMLElement;
  private readonly healthFill: HTMLElement;
  private readonly healthValue: HTMLElement;
  private readonly unsubscribe: () => void;

  constructor(stats: PlayerStats) {
    this.element = document.createElement('div');
    this.element.className = 'stats-hud stats-hud-astronaut';

    const health = createStatRow('HEALTH', 'stat-health');
    this.healthFill = health.fill;
    this.healthValue = health.value;
    this.element.append(health.row);

    this.unsubscribe = stats.subscribe((snap) => this.apply(snap));
  }

  show(): void {
    this.element.classList.add('is-visible');
  }

  hide(): void {
    this.element.classList.remove('is-visible');
  }

  dispose(): void {
    this.unsubscribe();
    this.element.remove();
  }

  private apply(snap: PlayerStatsSnapshot): void {
    applyBar(this.healthFill, this.healthValue, snap.health, snap.healthMax);
  }
}
